'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-intrinsics/abs.js
// module id = 91
// module chunks = 0